
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"44","height":"70"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('filter',{attrs:{"id":"Ellipse_61","x":"0","y":"0","width":"44","height":"44","filterUnits":"userSpaceOnUse"}},[_c('feOffset',{attrs:{"dy":"2"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"3","result":"blur"}}),_c('feFlood',{attrs:{"flood-color":"#111c24","flood-opacity":".22"}}),_c('feComposite',{attrs:{"operator":"in","in2":"blur"}}),_c('feComposite',{attrs:{"in":"SourceGraphic"}})])]),_c('g',{attrs:{"id":"Group_20462","data-name":"Group 20462","transform":"translate(-1505 -204)"}},[_c('g',{attrs:{"id":"Group_20461","data-name":"Group 20461"}},[_c('g',{attrs:{"transform":"translate(1505 204)","filter":"url(#Ellipse_61)"}},[_c('g',{attrs:{"id":"Ellipse_61-2","data-name":"Ellipse 61","transform":"translate(9 7)","fill":"#fff","stroke":"#dee8fd","stroke-width":"1"}},[_c('circle',{attrs:{"cx":"13","cy":"13","r":"13","stroke":"none"}}),_c('circle',{attrs:{"cx":"13","cy":"13","r":"12.5","fill":"none"}})])]),_c('g',{attrs:{"id":"Group_20460","data-name":"Group 20460","transform":"translate(6.518 7)","fill":"none","stroke":"#5c8df5","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1"}},[_c('path',{attrs:{"id":"Path_19227","data-name":"Path 19227","d":"M0 7V3.5h3.465","transform":"translate(1515.5 208.5)"}}),_c('path',{attrs:{"id":"Path_19228","data-name":"Path 19228","d":"M0 3.5V0h3.465","transform":"rotate(-90 868.741 -646.741)"}}),_c('path',{attrs:{"id":"Path_19229","data-name":"Path 19229","d":"M0 3.5V0h3.465","transform":"rotate(180 762.732 111)"}}),_c('path',{attrs:{"id":"Path_19230","data-name":"Path 19230","d":"M0 3.5V0h3.465","transform":"rotate(90 656.741 868.741)"}})])])])])
          )
        }
      }
    